module.exports = "<img [src]=\"'/assets/images/flags/' + locale.code + '.svg'\">\r\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/current-locale-code/current-locale-code.component.html
// module id = ./libs/atenea-cms/src/current-locale-code/current-locale-code.component.html
// module chunks = main